/** @file Last keyed frame of an animation across every channel (the default duration, spec §5.2). */
import type { AnimationDoc } from '@pose2d/format/types';

type Keys = readonly { f: number }[] | undefined;

/** Highest `f` of any key in `anim` (0 when nothing is keyed). */
export function lastKeyFrame(anim: AnimationDoc): number {
  const lists: Keys[] = [
    ...Object.values(anim.bones).flatMap((tl) => Object.values(tl)),
    ...Object.values(anim.slots).flatMap((tl) => Object.values(tl)),
    ...Object.values(anim.ik).flatMap((tl) => Object.values(tl)),
    ...Object.values(anim.deform),
    anim.drawOrder,
    anim.events,
  ];
  let last = 0;
  for (const keys of lists) for (const k of keys ?? []) last = Math.max(last, k.f);
  return last;
}
